export const it = {
    translation: {
        b: {
            cancel: 'Annulla',
            confirm: 'Conferma',
            send: 'Invia',
            done: 'Fatto',
            close: 'Chiudi',
            clear: 'Pulisci',
            copy_link: 'Copia link',
            export: 'Esporta',
            delete: 'Elimina',
            delete_confirm: 'Conferma eliminazione',
            duplicate: 'Duplica',
            share: 'Condividi',
            sign_in: 'Accedi',
            sign_up: 'Registrati',
            email_address: 'Indirizzo email',
            yes: 'Sì',
            no: 'No',
            back: 'Indietro',
            upgrade: 'Aggiorna piano',
            remove: 'Rimuovi',
            restore: 'Ripristina',
            archive: 'Archivia',
            rename: 'Rinomina',
            leave: 'Esci',
            import: 'Importa',
            continue: 'Continua',
            settings: 'Impostazioni',
            log_out: 'Esci',
            invite: 'Invita',
            invited: 'Invitato',
        },
        roles: {
            view: 'Lettore',
            comment: 'Commentatore',
            edit: 'Editor',
            admin: 'Admin',
            owner: 'Proprietario',
            member: 'Membro',
            remove: 'Rimuovi',
            more_roles: 'Altri ruoli...',
            change_role: 'Cambia ruolo...',
            remove_access: 'Rimuovi accesso...',
            remove_invite: 'Rimuovi invito...',
        },
        db_engine: {
            basic: 'SQL base',
            general: 'SQL generale',
        },
        socket_status: {
            reconnecting: 'Riconnessione...',
            offline: 'Sei offline. Riconnessione...',
        },
        loader: {
            diagram: 'Caricamento diagramma...',
        },
        m_languages: {
            title: 'Lingue',
            subtitle: 'Scegli una lingua'
        },
        m_feedback: {
            feature: {
                name: 'Richiesta funzionalità',
                desc: 'Manca una funzionalità di cui hai bisogno? Faccelo sapere — le tue idee contano'
            },
            feedback: {
                name: 'Condividi il tuo feedback',
                desc: 'Ci piacerebbe sapere cosa ne pensi'
            },
            support: {
                name: 'Supporto',
                desc: 'Qualcosa non funziona? Faccelo sapere — lo risolveremo rapidamente',
            },
            bug: {
                name: 'Segnala un problema',
                desc: 'Qualcosa non va? Segnalalo — ce ne occuperemo rapidamente',
            },
            integration: {
                name: 'Richiedi un’integrazione',
                desc: 'Il tuo feedback è molto importante per noi — lascia un breve messaggio',
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Grazie per il tuo suggerimento!',
                desc: 'Apprezziamo davvero il tempo che hai dedicato a condividere le tue idee — ci aiuta a migliorare.'
            },
            feedback: {
                name: 'Grazie per il tuo feedback!',
                desc: 'Apprezziamo davvero il tempo che hai dedicato a condividere le tue idee — ci aiuta a migliorare.'
            },
            support: {
                name: 'Grazie per averci contattato!',
                desc: 'Grazie per aver contattato il supporto — esamineremo la tua richiesta e ti risponderemo il prima possibile.',
            },
            bug: {
                name: 'Grazie per la segnalazione!',
                desc: 'Grazie per averlo segnalato — ci aiuta a risolvere i problemi più velocemente e a migliorare costantemente l’esperienza.',
            },
            contact: {
                name: 'Grazie per averci contattato!',
                desc: 'Abbiamo ricevuto il tuo messaggio e ti risponderemo il prima possibile.',
            },
            invite_people: {
                name: 'Invito inviato con successo!',
                desc: 'Grazie per averlo fatto sapere in giro — non vediamo l’ora di darle il benvenuto a bordo.',
            },
            integration: {
                name: 'Grazie per il tuo suggerimento!',
                desc: 'Apprezziamo davvero il tempo che hai dedicato a condividere le tue idee — ci aiuta a migliorare.',
            },
        },
        m_diagram_details: {
            name_place: 'Inserisci il nome del progetto',
            desc_place: 'Inserisci la descrizione del progetto'
        },
        m_quick_share: {
            title: 'Condivisione rapida',
            subtitle: '(Tramite link)'
        },
        m_export_img: {
            title: 'Esporta immagine'
        },
        search_menu: {
            placeholder: 'Cerca tabelle, colonne, tipi...',
            hint: '',
            no_results: 'Nessun risultato',
            quick_results: 'Risultati rapidi per',
            untitled: 'senza titolo',
            command_tag: 'comando',
            section_tables: 'Tabelle',
            section_columns: 'Colonne',
            section_canvas: 'Area di lavoro',
            section_export: 'Esporta',
            section_preferences: 'Preferenze',
            section_settings: 'Impostazioni',
            type_table: 'tabella',
            type_note: 'nota',
            cmd_new_table: 'Crea nuova tabella...',
            cmd_new_note: 'Crea nuova nota...',
            cmd_new_line: 'Crea nuova linea...',
            cmd_new_area: 'Crea nuova area...',
            cmd_export_image: 'Esporta immagine...',
            cmd_export_sql: 'Esporta codice SQL...',
            cmd_grid_style: 'Cambia vista griglia...',
        },
        canvas_table: {
            more_column: 'colonna in più',
            more_columns: 'colonne in più',
            tooltip_table: 'Tabella',
            tooltip_indexes: 'Indici',
            tooltip_enum: 'Enum',
            tooltip_default: 'Predefinito',
            tooltip_generated: 'Generato',
            tooltip_check: 'Check',
        },
        m_export_code: {
            title: 'Esporta codice {{db_engine}}',
            download_file: 'Scarica file',
            copy_code: 'Copia codice'
        },
        m_sign_in_remind: {
            title: 'Grazie per aver provato DB Design',
            subtitle: 'Accedi o registrati per aumentare il numero massimo di tabelle, salvare i diagrammi e sbloccare altre funzionalità.'
        },
        m_sign_in_restrict: {
            title: 'Accedi per fare di più nell’app',
            subtitle: 'Accedi o registrati per aumentare i limiti di tabelle, salvare i diagrammi e sbloccare più funzionalità.'
        },
        m_new_diagram: {
            title: 'Nuovo diagramma',
            subtitle: 'Scegli un motore di database',
            open_diagram: 'Apri diagramma',
            create_diagram: 'Crea diagramma',
            no_workspace: 'Crea prima uno spazio di lavoro per iniziare un diagramma.',
            build_something_new: 'Creiamo qualcosa di nuovo',
            create_diagram_section: 'Crea diagramma',
            clone_template_btn: 'Duplica modello',
        },
        m_diagram_name: {
            enter_new_name: 'Inserisci un nuovo nome del diagramma',
        },
        m_diagram_clone: {
            header: 'Duplica diagramma',
            copy_of_title: 'Copia di {{title}}',
        },
        m_diagram_rename: {
            header: 'Rinomina diagramma',
        },
        m_template_clone: {
            header: 'Crea un diagramma da modello',
        },
        m_diagram_delete: {
            header: 'Elimina diagramma',
            desc_prefix: 'Verrà eliminato: ',
        },
        m_diagram_archive: {
            header: 'Archivia diagramma',
            desc_prefix: 'Verrà archiviato: ',
        },
        m_diagram_restore: {
            header: 'Ripristina diagramma',
            desc_prefix: 'Verrà ripristinato: ',
        },
        m_diagram_import: {
            sql_name: 'Importa codice SQL',
            dbml_name: 'Importa codice DBML',
            // NOTE: en.js flags this placeholder copy as mismatched content (reads like
            // feedback-modal copy, not an SQL/DBML paste prompt). Kept verbatim in
            // translation since fixing the copy is a product call, not a translation one.
            placeholder: 'Ci piacerebbe conoscere la tua opinione!',
        },
        m_diagram_not_found: {
            header: 'Diagramma non trovato',
            desc: 'Non siamo riusciti a trovare il diagramma che stai cercando.',
            back_to_app: 'Torna all’app',
        },
        m_diagram_share: {
            header: 'Condividi diagramma – {{title}}',
            owner_only_invite: 'Solo il proprietario può invitare nuovi membri',
            invited_to_workspace: 'Invitato nello spazio di lavoro',
            you: 'tu',
            email_placeholder: 'Inserisci email',
            email_already_in_list: 'l’email è già nell’elenco',
            will_be_invited_to_workspace: 'sarà invitato nello spazio di lavoro',
        },
        m_invite_people: {
            header: 'Invita nello spazio di lavoro',
        },
        m_invite_revoke: {
            header: 'Rimuovi invito',
            desc_prefix: 'Rimuovi invito per ',
            desc_suffix: 'L’invito smetterà di funzionare.',
        },
        m_member_remove: {
            header: 'Rimuovi membro',
            desc_prefix: 'Rimuovere ',
            desc_suffix: ' da questo spazio di lavoro? Perderà l’accesso.',
        },
        m_template_details: {
            preview: 'Anteprima',
            use_template: 'Usa modello',
        },
        m_workspace_create: {
            header: 'Crea un nuovo spazio di lavoro',
            name_label: 'Nome',
            setup_config_label: 'Configurazione iniziale',
            setup_config_value: 'Spazio di lavoro vuoto',
            template_structure_label: 'Modello/Struttura',
            template_structure_value: 'Precarica struttura',
            placeholder: 'Inserisci il nome dello spazio di lavoro',
            create_button: 'Crea spazio di lavoro',
            creating: 'Creazione del tuo spazio di lavoro...',
        },
        m_workspace_delete: {
            header: 'Elimina spazio di lavoro',
            desc_prefix: 'Verrà eliminato definitivamente: ',
            confirm_prefix: 'Digita ',
            confirm_suffix: ' per confermare.',
        },
        m_workspace_leave: {
            header: 'Esci dallo spazio di lavoro',
            desc_prefix: 'Verrai rimosso da ',
            desc_suffix: '. Dovrai essere invitato di nuovo per rientrare.',
        },
        m_workspace_menu: {
            manage_members: 'Gestisci membri',
            switch_workspace: 'Cambia spazio di lavoro',
            workspaces_label: 'Spazi di lavoro',
            create_workspace: 'Crea uno spazio di lavoro...',
            switching: 'Cambio in corso',
        },
        m_profile_menu: {
            profile: 'Profilo',
            onboarding: 'Guida introduttiva',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Porta la tua collaborazione a un livello superiore', description: 'Passa a un piano superiore per sbloccare altri ruoli di condivisione come Admin, Editor, Commentatore, Lettore.' },
            workspaces: { title: 'Stai crescendo in fretta!', description: 'Passa a un piano superiore per creare e gestire più spazi di lavoro per i tuoi progetti e team.' },
            workspaces_canvas: { title: 'Espandi i tuoi spazi di lavoro', description: 'Passa a un piano superiore per creare e gestire più spazi di lavoro per i tuoi progetti e team.' },
            members: { title: 'Collabora su larga scala', description: 'Passa a un piano superiore per portare più membri nel tuo spazio di lavoro e collaborare in modo più efficace.' },
            diagrams: { title: 'Stai crescendo in fretta!', description: 'Passa a un piano superiore per creare più diagrammi e far crescere i tuoi progetti con sicurezza.' },
            tables: { title: 'Crea senza limiti', description: 'Passa a un piano superiore per aggiungere più tabelle e continuare a creare diagrammi più grandi e dettagliati.' },
            columns: { title: 'Crea senza limiti', description: 'Passa a un piano superiore per aggiungere più colonne e continuare a creare diagrammi più grandi e dettagliati.' },
            notes: { title: 'Crea senza limiti', description: 'Passa a un piano superiore per aggiungere più note e continuare a creare diagrammi più grandi e dettagliati.' },
            areas: { title: 'Crea senza limiti', description: 'Passa a un piano superiore per aggiungere più aree e continuare a creare diagrammi più grandi e dettagliati.' },
            pens: { title: 'Crea senza limiti', description: 'Passa a un piano superiore per aggiungere più disegni e continuare a creare diagrammi più grandi e dettagliati.' },
            default_title: 'Porta la tua collaborazione a un livello superiore',
            default_title_canvas: 'Migliora le tue prestazioni',
        },
        m_pricing_plans: {
            title: 'Passa a un piano superiore',
            subtitle: 'Puoi sempre passare a un piano superiore o inferiore in seguito',
            monthly: 'Mensile',
            annually: 'Annuale',
            billed_annually: 'Fatturazione annuale',
            billed_monthly: 'Fatturazione mensile',
            free_for_everyone: 'Gratuito per tutti',
            current_plan: 'Piano attuale',
            will_be_available_soon: 'Sarà disponibile a breve',
            price_period_user_month: '/utente/mese',
            plan_free: {
                name: 'Gratuito',
                button: 'Cambia piano',
                feature_realtime: 'Collaborazione in tempo reale',
                feature_members: '4 membri / spazio di lavoro',
                feature_diagrams: '4 diagrammi / spazio di lavoro',
                feature_tables: '40 tabelle / diagramma',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Tutte le funzionalità di Gratuito +',
                feature_members: 'Membri illimitati',
                feature_diagrams: 'Diagrammi illimitati',
                feature_tables: 'Tabelle illimitate',
                feature_history: 'Cronologia versioni',
                feature_admin_roles: 'Ruoli admin',
            },
        },
        sidebar: {
            new: 'Nuovo',
            pinned_diagrams: 'Diagrammi bloccati',
            pin_hint: 'Blocca i diagrammi per vederli qui',
            expand_sidebar: 'Espandi barra laterale',
            home_aria: 'Home di DB Design',
            open_menu: 'Apri menu',
            close_menu: 'Chiudi menu',
            sidebar_menu_aria: 'Menu della barra laterale',
            plan_suffix: 'piano',
            diagram_options: 'Opzioni diagramma',
            pin: 'Blocca',
            unpin: 'Sblocca',
            edit_details: 'Modifica dettagli',
            see_details: 'Vedi dettagli',
            invite_people: 'Invita persone',
            collapse_sidebar: 'Comprimi barra laterale',
            close_sidebar: 'Chiudi barra laterale',
            open_sidebar: 'Apri barra laterale',
            open_new_tab: 'Apri in una nuova scheda',
        },
        focus_controls: {
            show_top: 'Mostra controlli superiori',
            hide_top: 'Nascondi controlli superiori',
            show_left: 'Mostra controlli sinistri',
            hide_left: 'Nascondi controlli sinistri',
        },
        m_keyboard_shortcuts: {
            title: 'Scorciatoie da tastiera',
            general: {
                title1: 'Generale',
                title2: '',
                items: {
                    new_diagram: 'Crea diagramma',
                    new_chat: 'Nuova chat',
                    search: 'Azioni rapide o ricerca',
                    preferences: 'Preferenze',
                    settings: 'Impostazioni',
                    keyboard_shortcuts: 'Scorciatoie da tastiera',
                    toggle_sidebar: 'Mostra/nascondi barra laterale',
                    toggle_theme: 'Cambia tema',
                },
            },
            ctrl_left: {
                title1: 'Controlli',
                title2: '(Sinistra)',
                items: {
                    mouse_sel: 'Selezione con mouse / Modalità mano',
                    table: 'Tabella',
                    line: 'Linea',
                    area: 'Area',
                    note: 'Nota',
                    comment: 'Commento',
                    pen: 'Matita',
                    undo: 'Annulla',
                    redo: 'Ripristina'
                }
            },
            ctrl_top_left: {
                title1: 'Controlli',
                title2: '(In alto a sinistra)',
                items: {
                    export_img: 'Esporta immagine',
                    search: 'Cerca',
                    editor_panel: 'Pannello editor',
                    zoom_to_fit: 'Adatta allo schermo',
                }
            },
            ctrl_bottom_right: {
                title1: 'Controlli',
                title2: '(In basso a destra)',
                items: {
                    minimap: 'Minimappa',
                    full_screen: 'Schermo intero',
                    zoom_in: 'Zoom avanti',
                    zoom_out: 'Zoom indietro',
                    zoom_100: 'Zoom 100%'
                }
            },
            ctx_tab: {
                title1: 'Menu contestuale',
                title2: '(Tabella)',
                items: {
                    dupl_tab: 'Duplica tabella',
                    del_tab: 'Elimina tabella'
                }
            },
            ctx_del_tab: {
                title1: 'Menu contestuale',
                title2: '(Elimina tabella)',
                items: {
                    yes: 'Sì',
                    no: 'No'
                }
            },
            ctx_tab_col: {
                title1: 'Menu contestuale',
                title2: '(Colonna)', // (Colonna della tabella)
                items: {
                    add_col_below: 'Aggiungi colonna sotto',
                    focus_col_above: 'Porta il focus alla colonna sopra',
                    focus_col_below: 'Porta il focus alla colonna sotto',
                    move_col_up: 'Sposta colonna in alto',
                    move_col_down: 'Sposta colonna in basso',
                    dupl_col: 'Duplica colonna',
                    del_col: 'Elimina colonna'
                }
            },
            ctx_line: {
                title1: 'Menu contestuale',
                title2: '(Linea)',
                items: {
                    del_line: 'Elimina linea'
                }
            },
            ctx_area: {
                title1: 'Menu contestuale',
                title2: '(Area)',
                items: {
                    dupl_area: 'Duplica area',
                    del_area: 'Elimina area'
                }
            },
            ctx_multi: {
                title1: 'Menu contestuale',
                title2: '(Selezione multipla)',
                items: {
                    select_all: 'Seleziona tutti gli elementi',
                    create_area_for_select_els: 'Crea area per gli elementi selezionati',
                    dupl_select_els: 'Duplica elementi selezionati',
                    del_select_els: 'Elimina elementi selezionati'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Selezione con mouse',
                table: 'Tabella',
                line: 'Linea',
                area: 'Area',
                note: 'Nota',
                comment: 'Commento',
                pen: 'Matita',
                undo: 'Annulla',
                redo: 'Ripristina'
            },
            ctrl_top_left: {
                home: 'Home',
                name: 'Informazioni sul diagramma',
                editor: 'Editor',
                search: 'Ricerca',
                export: 'Opzioni di esportazione',
                view_mode: 'Modalità di visualizzazione',
                zoom_to_fit: 'Adatta allo schermo',
                grid: 'Vista griglia',
                history: 'Cronologia',
                main_menu: 'Menu principale',
                new_diagram: 'Nuovo diagramma',
            },
            ctrl_top_right: {
                feature_req: 'Richiesta funzionalità',
                feedback: 'Invia feedback',
                sign_in: 'Accedi',
                quick_share: 'Condivisione rapida'
            },
            ctrl_bottom_right: {
                full_screen: 'Schermo intero',
                minimap: 'Minimappa',
                zoom_out: 'Zoom indietro',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Zoom avanti',
                info: 'Informazioni e risorse'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Predefinito',
                        blue: 'Blu',
                        green: 'Verde',
                        red: 'Rosso',
                        purple: 'Viola',
                        violet: 'Violetto'
                    },
                    borders: {
                        none: 'Nessuno',
                        solid: 'Continuo',
                        dashed: 'Tratteggiato',
                        dotted: 'Punteggiato'
                    },
                    color: 'Colore',
                    border: 'Bordo',
                    description: 'Descrizione',
                    description_table_place: 'Descrizione tabella',
                    description_column_place: 'Descrizione colonna',
                    description_line_place: 'Descrizione linea',
                    description_note_place: 'Descrizione nota',
                    description_area_place: 'Descrizione area',
                    description_pen_place: 'Descrizione matita',
                    hide_menu: 'Nascondi menu',
                    show_menu: 'Mostra menu'
                },
                tab_col: {
                    add_col_below: 'Aggiungi colonna sotto',
                    add_col_above: 'Aggiungi colonna sopra',
                    key: 'Key',
                    keys: {
                        none: 'Nessuna',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Nessuno',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Sposta colonna in basso',
                    move_col_up: 'Sposta colonna in alto',
                    more_functions: 'Altre funzioni'
                },
                line: {
                    change_connects: 'Modifica connettori',
                    connects: {
                        empty: 'Vuoto',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Filtra elementi'
                },
                note: {
                    link_placeholder: 'Inserisci un link',
                    link_apply: 'Aggiungi',
                    link_remove: 'Rimuovi',
                    link_edit: 'Modifica',
                    link_needs_selection: 'Seleziona il testo da collegare',
                    bulleted_list: 'Elenco',
                    numbered_list: 'Elenco numerato',
                    font_style: 'Stile carattere',
                    alignment: 'Allineamento',
                    align_left: 'Sinistra',
                    align_center: 'Centro',
                    align_right: 'Destra',
                    link: 'Link',
                    monospace: 'Monospazio',
                    bold: 'Grassetto',
                    italic: 'Corsivo',
                    underline: 'Sottolineato',
                    strikethrough: 'Barrato',
                },
                multi: {
                    filter: 'Filtra selezione',
                    create_area: 'Crea area'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Completo',
            keys_only: 'Solo chiavi',
            names_only: 'Solo nomi'
        },
        dropdown_ctrl_grid: {
            none: 'Nessuno',
            lines: 'Linee',
            dots: 'Punti',
        },
        dropdown_ctrl_export: {
            export_img: 'Esporta immagine',
            export_code: 'Esporta codice SQL'
        },
        dropdown_ctrl_settings: {
            back_home: 'Torna alla home',
            sign_in: 'Accedi',
            preferences: 'Preferenze',
            new_project: 'Nuovo progetto',
            import_diagram: 'Importa diagramma',
            duplicate_diagram: 'Duplica diagramma',
            keyboard_shortcuts: 'Scorciatoie da tastiera',
            languages: 'Lingue',
            view: 'Vista',
            upgrade_plan: 'Passa a un piano superiore',
            language: 'Lingua',
            mouse_trackpad: 'Mouse o trackpad',
            background_color: 'Colore di sfondo',
            grid_layout: 'Layout griglia',
            view_mode: 'Modalità di visualizzazione',
            show_align_lines: 'Mostra linee di allineamento',
            show_members_cursors: 'Mostra i cursori dei membri',
            show_comments: 'Mostra commenti',
            undo_redo_controls: 'Controlli annulla/ripeti',
            show_scrollbars: 'Mostra barre di scorrimento',
            opt_auto: 'Automatico',
            opt_trackpad: 'Trackpad',
            opt_mouse: 'Mouse',
            opt_default: 'Scuro (predefinito)',
            opt_gray: 'Grigio',
            opt_blue: 'Blu',
            opt_purple: 'Viola',
            opt_violet: 'Violetto',
            opt_green: 'Verde',
            opt_red: 'Rosso',
            opt_yellow: 'Giallo',
            opt_dots: 'Punti',
            opt_lines: 'Linee',
            opt_none: 'Nessuno',
            opt_full: 'Completo',
            opt_keys: 'Chiavi',
            opt_names: 'Nomi',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Invia feedback',
            keyboard_shortcuts: 'Scorciatoie da tastiera',
            languages: 'Lingue',
            homepage: 'Pagina iniziale'
        },
        n: {
            default: 'Caricamento…',
            file_ready_to_download: 'Il file è pronto per il download',
            code_copied: 'Il codice è stato copiato',
            link_copied: 'Il link è stato copiato',
            username_copied: 'Nome utente copiato negli appunti',
            email_copied: 'Email copiata negli appunti',
            please_enter_message: 'Inserisci un messaggio',
            invalid_email: 'Email non valida',
            note_link_unsupported_protocol: 'Tipo di link non supportato. Usa https, http, mailto.',
            something_wrong_contact: 'Qualcosa è andato storto. Ricarica la pagina o contattaci.',
            something_wrong: 'Qualcosa è andato storto. Ricarica la pagina.',
            sending: 'Invio…',
            request_sent: 'La richiesta è stata inviata. Grazie!',

            please_enter_email: 'Inserisci l’indirizzo email',
            changing: 'Modifica in corso...',
            role_changed: 'Ruolo modificato',
            removing: 'Rimozione in corso...',
            member_removed: 'Membro rimosso',
            inviting: 'Invito in corso...',
            invite_sent: 'Invito inviato',
            added_to_diagram: 'Aggiunto al diagramma',
            invite_removed: 'Invito rimosso',
            role_not_allowed_on_plan: 'Questo ruolo non è disponibile con il tuo piano. Passa a un piano superiore per assegnarlo.',
            already_diagram_member: 'Questa persona ha già accesso al diagramma.',
            cannot_invite_to_workspace: 'Chiedi a un admin dello spazio di lavoro di invitare questa persona.',
            saving: 'Salvataggio in corso...',
            saved: 'Salvato',
            diagram_renamed: 'Diagramma rinominato',
            diagram_updated: 'Diagramma aggiornato',
            duplicating: 'Duplicazione in corso...',
            diagram_duplicated: 'Diagramma duplicato',
            deleting: 'Eliminazione in corso...',
            diagram_archived: 'Diagramma archiviato',
            diagram_deleted: 'Diagramma eliminato',
            restoring: 'Ripristino in corso...',
            diagram_restored: 'Diagramma ripristinato',
            diagram_pinned: 'Diagramma bloccato',
            diagram_unpinned: 'Diagramma sbloccato',
            creating: 'Creazione in corso...',
            diagram_created: 'Diagramma creato',
            forbidden: 'Non hai accesso a questa risorsa.',
            invite_already_pending: 'This person already has a pending invitation.',
            already_member: 'Già membro dello spazio di lavoro',
            cannot_invite_self: 'Non puoi invitare te stesso',
            workspace_not_found: 'Workspace not found. Refresh the page and try again.',
            diagram_not_found: 'Diagramma non trovato.',
            has_diagram_members: 'Il diagramma ha membri attivi',
            seat_limit_reached: 'Hai raggiunto il limite di posti del tuo piano. Passa a un piano superiore per invitare altre persone.',
            feature_not_in_plan: 'Questa funzionalità non è inclusa nel tuo piano attuale.',
            subscription_expired: 'Il tuo abbonamento è scaduto. Rinnovalo per continuare a usarlo.',
            subscription_inactive: 'Il tuo abbonamento non è attivo. Aggiorna i dati di fatturazione.',
            plan_limit_generic: 'Il tuo piano non consente questa azione. Passa a un piano superiore per continuare.',

            // Auth / profile
            session_expired: 'La tua sessione è scaduta — accedi di nuovo.',
            profile_updated: 'Profilo aggiornato',
            profile_update_failed: 'Impossibile aggiornare il profilo.',
            account_delete_failed: 'Impossibile eliminare l’account.',

            // Preferences
            couldnt_save: 'Impossibile salvare le modifiche',
            try_again: 'Qualcosa è andato storto. Riprova.',

            // Workspace
            not_workspace_member: 'Non sei membro di questo spazio di lavoro.',
            workspace_switch_failed: 'Impossibile cambiare spazio di lavoro. Riprova.',
            workspace_create_failed: 'Impossibile creare lo spazio di lavoro. Riprova.',
            invalid_workspace_name: 'Nome dello spazio di lavoro non valido',
            workspace_updated: 'Spazio di lavoro aggiornato',
            workspace_update_failed: 'Impossibile aggiornare lo spazio di lavoro. Riprova.',
            last_owner_cannot_leave: 'Sei l’unico proprietario. Rendi qualcun altro proprietario oppure elimina lo spazio di lavoro prima di uscire.',
            workspace_leave_failed: 'Impossibile uscire dallo spazio di lavoro. Riprova.',
            workspace_delete_forbidden: 'Solo il proprietario dello spazio di lavoro può eliminarlo.',
            workspace_has_active_billing: 'Annulla l’abbonamento di questo spazio di lavoro prima di eliminarlo.',
            workspace_deleted: 'Spazio di lavoro eliminato',
            workspace_delete_failed: 'Impossibile eliminare lo spazio di lavoro. Riprova.',
            member_remove_forbidden: 'Non hai il permesso di rimuovere questo membro.',
            member_remove_failed: 'Impossibile rimuovere il membro. Riprova.',
            cannot_remove_self: 'Usa "Esci dallo spazio di lavoro" per rimuovere te stesso.',
            cannot_remove_last_owner: 'Uno spazio di lavoro deve sempre avere un proprietario. Rendi prima qualcun altro proprietario.',
            invite_revoke_forbidden: 'Non hai il permesso di revocare questo invito.',
            invite_revoke_failed: 'Impossibile revocare l’invito. Riprova.',
        },
        dashboard: {
            doc_title: 'Diagrammi',
            filter_all: 'Tutti',
            filter_mydiagrams: 'I miei diagrammi',
            filter_shared: 'Condivisi con me',
            filter_archived: 'Archiviati',
            empty_all: 'Nessun diagramma in "Tutti i diagrammi"',
            empty_mydiagrams: 'Nessun diagramma in "I miei diagrammi"',
            empty_shared: 'Nessun diagramma in "Condivisi con me"',
            empty_archived: 'Nessun diagramma in "Archiviati"',
            example_diagram_badge: 'Diagramma di esempio',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: "Torna all'app",
                group_personal: 'Personale',
                group_organization: 'Organizzazione',
                billing: 'Fatturazione',
            },
            profile: {
                member_since: 'Membro dal {{date}}',
                general: 'Generale',
                email: 'Email',
                full_name: 'Nome completo',
                full_name_placeholder: 'Inserisci il nome',
                account_protection: 'Protezione dell’account',
                mfa_label: 'Autenticazione a più fattori (MFA)',
                mfa_sub: 'Ulteriore livello di sicurezza per l’account · Disponibile a breve',
                mfa_enable: 'Attiva MFA',
                mfa_soon_tooltip: 'Sarà disponibile a breve',
                workspace_access: 'Accesso allo spazio di lavoro',
                leave_workspace: 'Esci dallo spazio di lavoro',
                leave_workspace_sub: 'Rimuoviti dallo spazio di lavoro',
                leave_owner_tooltip: 'Trasferisci la proprietà prima di uscire dallo spazio di lavoro',
            },
            workspace: {
                header: 'Spazio di lavoro',
                general: 'Generale',
                name_label: 'Nome dello spazio di lavoro',
                name_placeholder: 'nome dello spazio di lavoro',
                stat_member_singular: 'Membro',
                stat_member_plural: 'Membri',
                stat_team_singular: 'Team',
                stat_team_plural: 'Team',
                members_section: 'Membri',
                no_members: 'Nessun membro',
                count_member_singular: 'membro',
                count_member_plural: 'membri',
                view_members_btn: 'Visualizza membri',
                danger_zone: 'Zona pericolosa',
                delete_workspace: 'Elimina spazio di lavoro',
                delete_workspace_sub: 'Questo eliminerà definitivamente lo spazio di lavoro',
                delete_owner_only_tooltip: 'Solo i proprietari possono eliminare gli spazi di lavoro',
                delete_cancel_sub_tooltip: 'Annulla il tuo abbonamento prima di eliminare lo spazio di lavoro',
            },
            members: {
                header: 'Membri',
                col_name: 'Nome',
                col_email: 'Email',
                col_role: 'Ruolo',
                col_joined: 'Iscritto il',
                active_members: 'Membri attivi',
                invited_section: 'Invitati',
                no_members: 'Ancora nessun membro.',
                options_aria: 'Opzioni',
                leave_workspace_item: 'Esci dallo spazio di lavoro...',
                remove_member_item: 'Rimuovi membro...',
                remove_owner_only_tooltip: 'Solo i proprietari possono rimuovere membri',
                remove_owner_row_tooltip: 'Il proprietario non può essere rimosso dallo spazio di lavoro',
                remove_invite_item: 'Rimuovi invito...',
                role_invited_suffix: '{{role}} (Invitato)',
            },
            preferences: {
                section_general: 'Generale',
                section_diagram_defaults: 'Impostazioni del diagramma',
                section_diagram_views: 'Visualizzazioni del diagramma',
                section_notifications: 'Notifiche',
                theme_label: 'Tema dell’interfaccia',
                theme_sub: 'Seleziona lo schema colori dell’interfaccia',
                theme_dark: 'Scuro',
                theme_light: 'Chiaro',
                theme_system: 'Sistema',
                language_sub: 'Seleziona la lingua dell’interfaccia',
                timezone_label: 'Fuso orario',
                timezone_sub: 'Seleziona il tuo fuso orario',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawaii',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Ora del Pacifico',
                    denver: 'GMT-07:00 — Ora delle Montagne Rocciose',
                    chicago: 'GMT-06:00 — Ora Centrale',
                    new_york: 'GMT-05:00 — Ora Orientale',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — San Paolo',
                    azores: 'GMT-01:00 — Azzorre',
                    london: 'GMT+00:00 — Londra',
                    paris: 'GMT+01:00 — Parigi, Berlino',
                    kyiv: 'GMT+02:00 — Kyiv, Atene',
                    istanbul: 'GMT+03:00 — Istanbul',
                    dubai: 'GMT+04:00 — Dubai',
                    karachi: 'GMT+05:00 — Karachi',
                    kolkata: 'GMT+05:30 — India',
                    dhaka: 'GMT+06:00 — Dacca',
                    bangkok: 'GMT+07:00 — Bangkok, Giacarta',
                    shanghai: 'GMT+08:00 — Pechino, Singapore',
                    tokyo: 'GMT+09:00 — Tokyo, Seul',
                    sydney: 'GMT+10:00 — Sydney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Scegli i controlli di navigazione della tela',
                background_sub: 'Scegli un colore di sfondo per la tela',
                grid_sub: 'Scegli il layout della griglia della tela',
                show_align_lines_sub: 'Mostra le linee durante l’allineamento degli oggetti',
                show_cursors_sub: 'Mostra i cursori degli altri collaboratori',
                show_comments_sub: 'Mostra i commenti sulla tela',
                show_scrollbars_sub: 'Mostra le barre di scorrimento durante la navigazione nella tela',
                show_undo_redo_label: 'Mostra i controlli annulla/ripristina',
                show_undo_redo_sub: 'Mostra i controlli per annullare e ripristinare le modifiche',
                notif_shared_label: 'Diagramma condiviso con me',
                notif_shared_sub: 'Quando qualcuno condivide un diagramma con me',
                notif_mentions_label: 'Menzioni nei commenti',
                notif_mentions_sub: 'Quando qualcuno mi menziona con @ in un commento',
                notif_updates_label: 'Aggiornamenti sul prodotto',
                notif_updates_sub: 'Aggiornamenti mensili su nuove funzionalità e miglioramenti',
                show: 'Mostra',
                hide: 'Nascondi',
                on: 'Attivo',
                off: 'Disattivo',
            },
            billing: {
                header: 'Fatturazione',
                plan_free: 'Piano gratuito',
                status_current: 'Attuale',
                no_renewal_needed: 'Nessun rinnovo necessario',
                payment_header: 'Pagamento',
                no_payments: 'Nessun pagamento',
                invoices_header: 'Fatture',
                no_invoices: 'Nessuna fattura',
            },
            usage: {
                doc_title: 'Utilizzo',
                overview_title: 'Panoramica',
                resource_limits_title: 'Limiti delle risorse',
                label_diagrams: 'Diagrammi',
                label_tables: 'Tabelle',
                label_areas: 'Aree',
                label_notes: 'Note adesive',
                label_members: 'Membri',
                label_tables_per_diagram: 'Tabelle / Diagramma',
                label_areas_per_diagram: 'Aree / Diagramma',
                label_notes_per_diagram: 'Note / Diagramma',
                need_more_title: 'Ti serve di più?',
                need_more_free: 'Passa a Basic per più diagrammi, cronologia delle versioni e supporto prioritario.',
                need_more_paid: 'Passa a Professional per diagrammi illimitati, più posti e funzionalità avanzate.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Pagina non trovata',
                dont_have_access_to_diagram: 'Non hai accesso a questo diagramma oppure potrebbe non esistere più.',
                back_home: 'Torna alla home'
            },
            error: {
                title: 'Errore',
                link_is_invalid: 'Questo link non è valido o è stato inserito in modo errato.',
                something_wrong: 'Qualcosa è andato storto.',
                back_home: 'Torna alla home',
                please_try_later: 'Riprova più tardi',
            },
            billing_success: {
                doc_title: 'Piano aggiornato',
                heading: 'Pagamento riuscito',
                subtitle: 'Il tuo piano è stato aggiornato con successo.',
                cta: 'Inizia a progettare',
            },
            email_verified: {
                doc_title: 'Email verificata',
            },
            forgot_password: {
                doc_title: 'Password dimenticata',
            },
            password_updated: {
                doc_title: 'Password aggiornata',
            },
            reset_password: {
                doc_title: 'Reimposta password',
            },
            check_email: {
                doc_title: 'Controlla la tua email',
            },
            sign_in: {
                doc_title: 'Accedi a {{product}}',
            },
            sign_up: {
                doc_title: 'Registrati su {{product}}',
            },
        },
    }
};

export const itMeta = {
    lang_origin: 'Italiano',
    lang_eng: 'Italian',
    lang_code: 'it',
};
